module.exports = __webpack_public_path__ + "static/media/VsCode.502e32f5.png";